export function krutidevToUnicode(text) {
  let kruti = text;

  const map = {
    "d+": "क्र",
    "dd": "क्क",
    "dk": "का",
    "d": "क",

    "f": "ि",
    "h": "ी",
    "k": "ा",

    "j": "र",
    "l": "ल",
    "g": "ह",

    "s": "े",
    "S": "ै",
    "ks": "ो",

    "q": "ु",
    "w": "ू",

    "a": "ं",
    "%": "ः",
    "W": "ँ",
    "~": "्"
  };

  Object.keys(map)
    .sort((a, b) => b.length - a.length)
    .forEach(key => {
      kruti = kruti.replace(new RegExp(key, "g"), map[key]);
    });

  // fix pre-matra
  kruti = kruti.replace(/ि([क-ह])/g, "$1ि");

  return kruti;
}